import React from "react";
import Icon, { type IconProps } from "./icon";

export default function CloseIcon({ className, width = 20, height = 20 }: IconProps) {
  return (
    <Icon
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
    >
      <path
        d="M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
